/* istanbul ignore file: Directive */
'use strict';

/**
 * Checks if the input is a valid trigger to perform a password reset.
 * i.e. A valid email address or a valid msisdn. In the later case,
 * it will bind to the normalized version of the model.
 */
customerZone.directive('validateCustomerIdentifier', ['utils', function(utils){
    return {
        require: 'ngModel',
        link: function(scope, elem, attrs, ctrl) {
            ctrl.$parsers.push(function(value){
                if (value.indexOf('@') > -1  ) {
                    return utils.validateEmail(value) ? value : undefined;
                }
                else {
                    var valid = utils.checkMsisdn(value);
                    if (!valid.valid) return undefined;
                    return valid.normalized;
                }
            });
        }
    };
}]);
